import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ENVIRONMENT } from '@env/environment';
import { Federation } from '@federations/models/federation';

@Injectable()
export class FederationsService {
  readonly #httpClient = inject(HttpClient);
  readonly #apiUrl = `${ENVIRONMENT.coreApi.endpoint}/federations`;

  list(): Observable<Federation[]> {
    return this.#httpClient.get<Federation[]>(`${this.#apiUrl}/list`);
  }

  create(federation: Federation): Observable<Federation> {
    return this.#httpClient.post<Federation>(this.#apiUrl, federation);
  }

  update(federation: Federation): Observable<Federation> {
    return this.#httpClient.put<Federation>(
      `${this.#apiUrl}/${federation.id}`,
      federation
    );
  }
}
